import { Pipe, PipeTransform } from '@angular/core';
import * as momemt from 'moment';
import { ValidationService } from '../providers/validation.service'

@Pipe({
  name: 'yearsGapBetweenDates'
})
export class YearsGapBetweenDatesPipe implements PipeTransform {
    constructor(private Validation: ValidationService) { }
  transform(value: Date, date2?: Date, precise?: boolean): string {
      return this.Validation.yearsGapBetweenDates(value, date2);
  }
}
